webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FullScreen__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FullScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ScrollingContent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ScrollingContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ScrollingContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dynamic__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dynamic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Dynamic__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */])

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
    },
    {
      path: '/fullscreen',
      name: 'FullScreen',
      component: __WEBPACK_IMPORTED_MODULE_3__components_FullScreen___default.a
    },
    {
      path: '/scrolling',
      name: 'ScrollingContent',
      component: __WEBPACK_IMPORTED_MODULE_4__components_ScrollingContent___default.a
    },
    {
      path: '/dynamic',
      name: 'Dynamic',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Dynamic___default.a
    }
  ]
});


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwipeItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwipeItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SwipeItem__);



var VSwipe = {
  install: function install(Vue, options) {
    Vue.component('swipe', __WEBPACK_IMPORTED_MODULE_0__Swipe___default.a);
    Vue.component('swipe-item', __WEBPACK_IMPORTED_MODULE_1__SwipeItem___default.a);
  }
};

/* harmony default export */ __webpack_exports__["a"] = VSwipe;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VSwipe);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app'
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [0, 1, 2],
      state: 1 };
  },


  methods: {
    plus: function plus() {
      var _this = this;

      this.state = 0;
      setTimeout(function () {
        _this.items.push(_this.items[_this.items.length - 1] + 1);
        _this.resize();
        _this.state = 1;
      });
    },
    minus: function minus() {
      if (this.items.length <= 2) {
        alert('最少得有两个 SwipeItem 吧');
        return;
      }
      this.items.pop();
      this.resize();
    },
    resize: function resize() {
      this.$refs.mySwipe.resize();
    }
  }
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      swipeOptions: {
        startSlide: 0,
        speed: 300,
        auto: 4000,
        continuous: true,
        disableScroll: false,
        stopPropagation: false,
        callback: function callback(index, slide) {
          console.log('slide changes');
        },
        transitionEnd: function transitionEnd(index, slide) {
          console.log('slide transition ends');
        }
      }
    };
  }
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  methods: {
    prev: function prev() {
      this.$refs.mySwipe.prev();
    },
    next: function next() {
      this.$refs.mySwipe.next();
    }
  }
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function mounted() {
    this.list = new Array(100);
  }
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swipe_js_iso__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swipe_js_iso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swipe_js_iso__);




function noop() {}

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    options: {
      startSlide: { type: Number, default: 0 },
      speed: { type: Number, default: 400 },
      auto: { type: Number, default: 3000 },
      continuous: { type: Boolean, default: true },
      disableScroll: { type: Boolean, default: false },
      stopPropagation: { type: Boolean, default: false },
      callback: { type: Function, default: noop },
      transitionEnd: { type: Function, default: noop }
    }
  },

  data: function data() {
    return {
      swipe: undefined
    };
  },
  mounted: function mounted() {
    this.swipe = new __WEBPACK_IMPORTED_MODULE_0_swipe_js_iso___default.a(this.$el, this.options);
  },
  destroyed: function destroyed() {
    this.swipe.kill();
  },


  methods: {
    prev: function prev() {
      this.swipe.prev();
    },
    next: function next() {
      this.swipe.next();
    },
    getPos: function getPos() {
      return this.swipe.getPos();
    },
    getNumSlides: function getNumSlides() {
      return this.swipe.getNumSlides();
    },
    slide: function slide(index, duration) {
      this.swipe.slide(index, duration);
    },
    resize: function resize() {
      setTimeout(this.swipe.setup, 0);
    }
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  "data-v-56a8fad5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  "data-v-7285f968",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('back-button'), _vm._v(" "), _c('swipe', {
    staticClass: "swipe-fullscreen",
    attrs: {
      "options": _vm.swipeOptions
    }
  }, [_c('swipe-item', {
    staticStyle: {
      "background": "#EA5A49"
    }
  }), _vm._v(" "), _c('swipe-item', {
    staticStyle: {
      "background": "#44CC00"
    }
  }), _vm._v(" "), _c('swipe-item', {
    staticStyle: {
      "background": "#FFBD17"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-item"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('back-button'), _vm._v(" "), _c('div', {
    staticClass: "code-name",
    staticStyle: {
      "padding-top": "90px"
    }
  }, [_vm._v("\n    Dynamic Items\n  ")]), _vm._v(" "), _c('swipe', {
    ref: "mySwipe",
    class: {
      'hide': !_vm.state
    },
    staticStyle: {
      "max-width": "500px",
      "margin": "0 auto"
    }
  }, _vm._l((_vm.items), function(it) {
    return _c('swipe-item', {
      key: it
    }, [_c('b', [_vm._v(_vm._s(it))])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.minus()
      }
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('span', [_vm._v("SwipeItem Count: " + _vm._s(_vm.items.length))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.plus()
      }
    }
  }, [_vm._v(" + ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "github-corner",
    attrs: {
      "href": "https://github.com/wangdahoo/vswipe",
      "aria-label": "View source on Github"
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#70B7FD",
      "color": "#fff",
      "position": "absolute",
      "top": "0",
      "border": "0",
      "right": "0"
    },
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 250 250",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
    }
  }), _c('path', {
    staticClass: "octo-arm",
    staticStyle: {
      "transform-origin": "130px 106px"
    },
    attrs: {
      "d": "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
      "fill": "currentColor"
    }
  }), _c('path', {
    staticClass: "octo-body",
    attrs: {
      "d": "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('swipe', {
    ref: "mySwipe",
    staticStyle: {
      "max-width": "500px",
      "margin": "0 auto"
    }
  }, [_c('swipe-item', [_c('b', [_vm._v("0")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("3")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("4")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("5")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("6")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("7")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("8")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("9")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("10")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("11")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("12")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("13")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("14")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("15")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("16")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("17")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("18")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("19")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("20")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_vm._v("prev")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("next")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Examples:")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/scrolling"
    }
  }, [_vm._v("Scrolling Content")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fullscreen"
    }
  }, [_vm._v("Fullscreen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dynamic"
    }
  }, [_vm._v("Dynamic Swipe Items")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-name"
  }, [_vm._v("\n    VSwipe "), _c('sup', [_vm._v("1.0")]), _vm._v(" "), _c('p', [_vm._v("\n      Brad Birdsall's Swipe.js as a Vue component.\n    ")])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "vswipe": ""
    }
  }, [_c('div', {
    staticClass: "swipe-wrap"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('back-button'), _vm._v(" "), _c('swipe', {
    staticClass: "container"
  }, [_c('swipe-item', [_c('h1', [_vm._v("1")])]), _vm._v(" "), _c('swipe-item', [_c('h1', [_vm._v("2")])]), _vm._v(" "), _c('swipe-item', [_c('div', {
    staticClass: "scroll-wrap"
  }, [_c('div', {
    staticClass: "scroll"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('p', {
      domProps: {
        "textContent": _vm._s(index)
      }
    })
  }))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vswipe__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BackButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BackButton__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vswipe__["a" /* default */])


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('back-button', __WEBPACK_IMPORTED_MODULE_4__components_BackButton___default.a)

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
})


/***/ })
],[38]);


// WEBPACK FOOTER //
// static/js/app.77f5646dd9bdeaa89fce.js